// sales-page/src/utils/fingerprint.js
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

export const initFingerprint = async () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

export const getVisitorFingerprint = async () => {
  try {
    const fp = await initFingerprint();
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error('Fingerprint error:', error);
    return `fallback-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
};

export const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  let deviceType = 'unknown';
  
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    deviceType = 'tablet';
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    deviceType = 'mobile';
  } else {
    deviceType = 'desktop';
  }

  const getBrowserName = () => {
    if (ua.indexOf('Chrome') > -1) return 'Chrome';
    if (ua.indexOf('Safari') > -1) return 'Safari';
    if (ua.indexOf('Firefox') > -1) return 'Firefox';
    if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) return 'IE';
    if (ua.indexOf('Edge') > -1) return 'Edge';
    return 'Unknown';
  };

  const getBrowserVersion = () => {
    try {
      let match;
      if (ua.indexOf('Chrome') > -1) {
        match = ua.match(/Chrome\/([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (ua.indexOf('Firefox') > -1) {
        match = ua.match(/Firefox\/([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (ua.indexOf('Edge') > -1) {
        match = ua.match(/Edge\/([\d.]+)/) || ua.match(/Edg\/([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (ua.indexOf('Safari') > -1) {
        match = ua.match(/Version\/([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (ua.indexOf('MSIE') > -1) {
        match = ua.match(/MSIE ([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (ua.indexOf('Trident/') > -1) {
        match = ua.match(/rv:([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      return 'Unknown';
    } catch (e) {
      return 'Unknown';
    }
  };

  const getOSName = () => {
    if (ua.indexOf('Win') > -1) return 'Windows';
    if (ua.indexOf('Mac') > -1) return 'MacOS';
    if (ua.indexOf('Linux') > -1) return 'Linux';
    if (ua.indexOf('Android') > -1) return 'Android';
    if (ua.indexOf('iOS') > -1) return 'iOS';
    return 'Unknown';
  };

  const getOSVersion = () => {
    try {
      let match;
      if (/Android/.test(ua)) {
        match = ua.match(/Android ([\d.]+)/);
        return match ? match[1] : 'Unknown';
      }
      if (/iPhone|iPad|iPod/.test(ua)) {
        match = ua.match(/OS ([\d_]+)/);
        return match ? match[1].replace(/_/g, '.') : 'Unknown';
      }
      if (/Windows NT/.test(ua)) {
        match = ua.match(/Windows NT ([\d.]+)/);
        if (!match) return 'Unknown';
        const ntMap = {
          '10.0': '10',
          '6.3': '8.1',
          '6.2': '8',
          '6.1': '7',
          '6.0': 'Vista',
          '5.1': 'XP'
        };
        return ntMap[match[1]] || match[1];
      }
      if (/Mac OS X/.test(ua)) {
        match = ua.match(/Mac OS X ([\d_.]+)/);
        return match ? match[1].replace(/_/g, '.') : 'Unknown';
      }
      return 'Unknown';
    } catch (e) {
      return 'Unknown';
    }
  };

  return {
    device_type: deviceType,
    browser: getBrowserName(),
    browser_version: getBrowserVersion(),
    operating_system: getOSName(),
    os_version: getOSVersion(),
    user_agent: ua
  };
};

export const getGeoData = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return {
      country: data.country_name || null,
      country_code: data.country_code || null,
      region: data.region || null,
      city: data.city || null,
      timezone: data.timezone || null,
      latitude: data.latitude || null,
      longitude: data.longitude || null,
      ip_address: data.ip || null
    };
  } catch (error) {
    console.error('Geo data error:', error);
    return {
      country: null,
      country_code: null,
      region: null,
      city: null,
      timezone: null,
      latitude: null,
      longitude: null,
      ip_address: null
    };
  }
};